import { useCallback, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { updateTagNamesForDocuments } from '../../api/EcaServices';
import { useToast } from '../../contexts/toastContext/ToastContext';
import { t } from 'i18next';

export interface IUpdateTagNamesBody {
  allDocuments: boolean;
  documentIds: string[];
  searchId: number | null;
  tagFieldId: string | number | undefined;
  tagIds: number[];
}

export const useUpdateTagNames = (hideSuccessToast?: boolean) => {
  const { showToast } = useToast();
  const clientId = useSelector(
    (state: RootState) => state.selectedClient
  ).clientId;
  const projectId = useSelector((state: RootState) => state.reports).projectId;

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const params = useMemo(
    () => `?clientId=${clientId}&projectId=${projectId}`,
    [clientId, projectId]
  );

  const updateTagName = useCallback(
    async (
      taggingType: string,
      indexName: string,
      requestBody: IUpdateTagNamesBody,
      onSuccess?: (requestId?: string) => void,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onError?: (error: any) => void
    ) => {
      setIsLoading(true);
      try {
        const {
          data: { data },
        } = await updateTagNamesForDocuments(
          taggingType,
          `${params}&indexName=${indexName}`,
          requestBody
        );
        onSuccess && onSuccess(data?.requestId);
        if (!hideSuccessToast) {
          showToast(
            taggingType === 'tag'
              ? t('ecaDocList.bulkTagging.apply.initiated')
              : t('ecaDocList.bulkTagging.apply.initiatedUntag'),
            'success',
            5000,
            'center',
            'bottom'
          );
        }
      } catch (e) {
        onError && onError(e);
        showToast(
          t('eca.documentPreviewer.taggingPanel.taggingError'),
          'error',
          5000,
          'center',
          'bottom'
        );
      } finally {
        const toast = document.getElementById('aur-toast')
        toast?.focus()
        setIsLoading(false);
      }
    },
    [params, hideSuccessToast, showToast]
  );

  return {
    updateTagName,
    isLoading,
  };
};
